// extracted by mini-css-extract-plugin
export default {"tableHeader":"TableHead_tableHeader__6eCFj","scrollBar":"TableHead_scrollBar__2suRh"};